'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonTheme = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _BaseButton = require('./BaseButton.scss');

var _BaseButton2 = _interopRequireDefault(_BaseButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonTheme = exports.ButtonTheme = {
  CallToAction: 'callToAction',
  darkText: 'darkText',
  Secondary: 'secondary',
  Outline: 'outline'
};

var BaseButton = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(BaseButton, _Component);

  function BaseButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BaseButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BaseButton.__proto__ || (0, _getPrototypeOf2.default)(BaseButton)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function () {
      if (!_this.props.isInactive && !_this.props.loading) {
        _this.props.onClick();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BaseButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          className = _props.className,
          loading = _props.loading,
          isCenter = _props.isCenter;

      var buttonClassName = _BaseButton2.default.buttonContent + (className ? ' ' + className : '') + (icon ? ' ' + _BaseButton2.default.withIcon : '') + (this.props.isInactive ? ' ' + _BaseButton2.default.inactive : '') + (loading ? ' ' + _BaseButton2.default.loading : '');
      return _react2.default.createElement(
        'div',
        { className: buttonClassName },
        _react2.default.createElement(
          'div',
          {
            className: _BaseButton2.default.button + ' ' + (isCenter ? _BaseButton2.default.center : "") + ' ' + (this.props.theme ? _BaseButton2.default[this.props.theme] : ""),
            onClick: this.onClick
          },
          icon ? _react2.default.createElement('img', { src: icon }) : "",
          _react2.default.createElement(
            'div',
            { className: loading ? _BaseButton2.default.hide : _BaseButton2.default.text },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, this.props.buttonString, {
              values: this.props.buttonStringValue
            }))
          ),
          _react2.default.createElement(_components.LoadingIndicator, {
            loading: loading,
            className: _BaseButton2.default.loadingIndicator,
            theme: this.props.theme
          })
        )
      );
    }
  }]);
  return BaseButton;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  buttonString: _react.PropTypes.object.isRequired,
  buttonStringValue: _react.PropTypes.object,
  loading: _react.PropTypes.bool,
  icon: _react.PropTypes.string,
  isInactive: _react.PropTypes.bool,
  isCenter: _react.PropTypes.bool,
  onClick: _react.PropTypes.func.isRequired,
  theme: _react.PropTypes.string
}, _temp2);
exports.default = BaseButton;


//////////////////
// WEBPACK FOOTER
// ./src/components/BaseButton/BaseButton.js
// module id = 111
// module chunks = 0